import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-Enable",
  "use": "icon-Enable-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 8\" id=\"icon-Enable\">\r\n  <circle id=\"icon-Enable_椭圆_8\" data-name=\"椭圆 8\" cx=\"4\" cy=\"4\" r=\"4\" fill=\"#ec212d\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol